import { useEffect, useState } from "@wordpress/element";
const { Component } = wp.element;

import { __ } from "@wordpress/i18n";
import React from "react";
import PGinputSelect from "../input-select";
import PGinputText from "../input-text";

function Html(props) {
	if (!props.warn) {
		return null;
	}

	var onChange = props.onChange;

	var [options, setoptions] = useState(props.options); // Using the hook.

	useEffect(() => {
		onChange(options);
	}, [options]);

	return (
		<div className="w-[800px]">
			<div className="text-2xl font-bold mb-2">
				{__("reCAPTCHA", "user-verification")}
			</div>
			<p className="text-base mb-7">
				{__("Customize options for reCAPTCHA.", "user-verification")}{" "}
			</p>
			<div className="flex my-5 justify-between items-center ">
				<label className="w-[400px]" htmlFor="emailVerification">
					{__("Recaptcha version", "user-verification")}
				</label>
				<PGinputSelect
					inputClass="!py-1 px-2  border-2 border-solid"
					val={options?.version}
					options={[
						{ label: "Choose", value: "" },
						{ label: "V2 Checkbox", value: "v2_checkbox" },
						{ label: "V3", value: "v3" },
					]}
					onChange={(newVal) => {
						var optionsX = { ...options, version: newVal };
						setoptions(optionsX);
					}}
					multiple={false}
				/>
			</div>
			{options?.version.length > 0 && (
				<>
					<div className="flex  my-5  justify-between items-center">
						<label className="w-[400px]" htmlFor="emailVerification">
							{__("reCAPTCHA sitekey", "user-verification")}
						</label>
						<PGinputText
							value={options?.sitekey}
							className="!py-1 px-2 !border-2 !border-[#8c8f94] !border-solid w-full max-w-[400px]"
							onChange={(newVal) => {
								var optionsX = {
									...options,
									sitekey: newVal.target.value,
								};
								setoptions(optionsX);
							}}
						/>
					</div>
					<div className="flex  my-5  justify-between items-center">
						<label className="w-[400px]" htmlFor="emailVerification">
							{__("reCAPTCHA secret key", "user-verification")}
						</label>
						<PGinputText
							value={options?.secretkey}
							className="!py-1 px-2 !border-2 !border-[#8c8f94] !border-solid w-full max-w-[400px]"
							onChange={(newVal) => {
								var optionsX = {
									...options,
									secretkey: newVal.target.value,
								};
								setoptions(optionsX);
							}}
						/>
					</div>
					<div className="flex  my-5  justify-between items-center">
						<label className="w-[400px]" htmlFor="emailVerification">
							{__("Recaptcha on default login page", "user-verification")}
						</label>
						<PGinputSelect
							inputClass="!py-1 px-2  border-2 border-solid"
							val={options?.default_login_page}
							options={[
								{ label: "No", value: "no" },
								{ label: "Yes", value: "yes" },
							]}
							onChange={(newVal) => {
								var optionsX = { ...options, default_login_page: newVal };
								setoptions(optionsX);
							}}
							multiple={false}
						/>
					</div>
					<div className="flex  my-5  justify-between items-center">
						<label className="w-[400px]" htmlFor="emailVerification">
							{__(
								"Recaptcha on default registration page",
								"user-verification"
							)}
						</label>
						<PGinputSelect
							inputClass="!py-1 px-2  border-2 border-solid"
							val={options?.default_registration_page}
							options={[
								{ label: "No", value: "no" },
								{ label: "Yes", value: "yes" },
							]}
							onChange={(newVal) => {
								var optionsX = {
									...options,
									default_registration_page: newVal,
								};
								setoptions(optionsX);
							}}
							multiple={false}
						/>
					</div>
					<div className="flex  my-5  justify-between items-center">
						<label className="w-[400px]" htmlFor="emailVerification">
							{__(
								"Recaptcha on default reset password page",
								"user-verification"
							)}
						</label>
						<PGinputSelect
							inputClass="!py-1 px-2  border-2 border-solid"
							val={options?.default_lostpassword_page}
							options={[
								{ label: "No", value: "no" },
								{ label: "Yes", value: "yes" },
							]}
							onChange={(newVal) => {
								var optionsX = {
									...options,
									default_lostpassword_page: newVal,
								};
								setoptions(optionsX);
							}}
							multiple={false}
						/>
					</div>
					<div className="flex  my-5  justify-between items-center">
						<label className="w-[400px]" htmlFor="emailVerification">
							{__("Recaptcha on comment forms", "user-verification")}
						</label>
						<PGinputSelect
							inputClass="!py-1 px-2  border-2 border-solid"
							val={options?.comment_form}
							options={[
								{ label: "No", value: "no" },
								{ label: "Yes", value: "yes" },
							]}
							onChange={(newVal) => {
								var optionsX = { ...options, comment_form: newVal };
								setoptions(optionsX);
							}}
							multiple={false}
						/>
					</div>
				</>
			)}
		</div>
	);
}

class ReCaptcha extends Component {
	constructor(props) {
		super(props);
		this.state = { showWarning: true };
		this.handleToggleClick = this.handleToggleClick.bind(this);
	}
	handleToggleClick() {
		this.setState((state) => ({
			showWarning: !state.showWarning,
		}));
	}
	render() {
		var { onChange, options } = this.props;
		return (
			<Html
				onChange={onChange}
				options={options}
				warn={this.state.showWarning}
			/>
		);
	}
}
export default ReCaptcha;
